import script from "./CreateUpdateMetricGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateMetricGroup.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateMetricGroup.vue?vue&type=style&index=0&id=33e1135e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e1135e"]])

export default __exports__